<template>
    <header class=" z-50 flex justify-between text-default contrast-success">
        <router-link tag="div" class="p-4 cursor-pointer" to="/">
            <unicon name="home-alt"></unicon>
        </router-link>

<!--        <div class="p-4 cursor-pointer" @click="testRequest">-->
<!--            test request-->
<!--        </div>-->

        <div class="flex item-center" v-if="loggedIn">
            <div v-if="loggedIn" class="flex items-center px-2 cursor-pointer" @click="">

                <router-link class="text-xs mr-4" to="/quantities">Наличности</router-link>

                <unicon name="wifi-slash" v-if="!hasInternetConnection" class="mr-4"></unicon>
                <img class="w-8 h-8 rounded-full mr-2" v-if="logged_user.avatar" :src="avatarSrc(logged_user.avatar)"
                     @error="(e)=>{e.target.src= require('@/assets/missing_avatar.svg');}" alt="photo"/>
                <span v-if="logged_user.name" :class="{'text-red-600':logged_user.is_impersonate}"
                      class="py-2 hidden sm:inline text-xs">{{logged_user.name}}</span>

                <button class="btn btn-xs ml-2" @click="logout">
                    <unicon name="sign-out-alt"></unicon>
                </button>
            </div>
        </div>
    </header>
</template>
<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import ApiService from "../../services/api.service"

    export default {
        name: 'Header-side',
        computed: {
            ...mapGetters('auth', ['loggedIn']),
            ...mapGetters(['hasInternetConnection']),
            ...mapGetters('profile', ['logged_user']),
        },
        methods: {
            ...mapMutations('alert', ['alert_fire']),
            ...mapActions('auth', ['logout']),
            testRequest() {

                let data = {
                    name: 'Name',
                    pharmacy: 'Pharmacy',
                    city: 'RUSE',
                    gift_id: 1,
                    quantity: 0,
                    user_id: this.logged_user.id,
                    is_from_api: 1
                };

                ApiService.post("/api/quiz/make_gift", data)
            }
        }
    }
</script>